import React from 'react';
import { motion } from 'framer-motion';
interface CaseStudyContentProps {
  title: string;
  subtitle: string;
  role: string;
  timeline: string;
  client: string;
  outcome: string;
}
export function CaseStudyContent({
  title,
  subtitle,
  role,
  timeline,
  client,
  outcome
}: CaseStudyContentProps) {
  return <div className="bg-slate-900 text-white px-6 py-20 md:px-12 lg:px-24" data-id="element-10">
      <div className="max-w-7xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-12">
          <h1 className="mb-6 text-4xl font-bold leading-tight md:text-6xl lg:text-7xl" data-id="element-13">
            {title}
          </h1>
          <p className="mb-12 max-w-2xl text-xl font-light text-slate-200 md:text-2xl" data-id="element-14">
            {subtitle}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="grid grid-cols-2 gap-8 border-t border-white/20 pt-8 md:grid-cols-4" data-id="element-15">
          <div data-id="element-16">
            <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-slate-400" data-id="element-17">
              Role
            </h3>
            <p className="text-lg font-medium" data-id="element-18">{"Experience Strategist"}</p>
          </div>
          <div data-id="element-19">
            <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-slate-400" data-id="element-20">
              Timeline
            </h3>
            <p className="text-lg font-medium" data-id="element-21">{timeline}</p>
          </div>
          <div data-id="element-22">
            <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-slate-400" data-id="element-23">
              Client
            </h3>
            <p className="text-lg font-medium" data-id="element-24">{client}</p>
          </div>
          <div data-id="element-25">
            <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-slate-400" data-id="element-26">
              Outcome
            </h3>
            <p className="text-lg font-medium text-blue-300" data-id="element-27">{outcome}</p>
          </div>
        </motion.div>
      </div>
    </div>;
}